import { render, staticRenderFns } from "./WaitingListWebEdit.vue?vue&type=template&id=3bc47078&"
import script from "./WaitingListWebEdit.js?vue&type=script&lang=js&"
export * from "./WaitingListWebEdit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports